
export const getProfileDetails = (
  username, email
) => {
  return [
    { name: "Username", content: username },
    { name: "Email", content: email },

  ]
}